import CardHeader from '../../components/CardHeader.vue';
import CourseCard from './../../components/SpocCourseCard.vue';
import { Empty } from 'zhs-components';
import { Swiper, SwiperSlide } from 'swiper/vue/swiper-vue.js';
import SwiperCore, { Navigation, A11y, Autoplay } from 'swiper';
SwiperCore.use([Navigation, A11y, Autoplay]);
import 'swiper/swiper-bundle.min.css';
import CommonTitle from './CommonTitle.vue';
export default {
  props: {
    courseType: Number,
    menu: Object,
    userInfo: {
      type: Object,
      default: null
    }
  },
  components: {
    CourseCard,
    CardHeader,
    Empty,
    Swiper,
    SwiperSlide,
    CommonTitle
  },

  created() {
    this.getAuth();
    this.getHomeCourseList();
  },

  data() {
    return {
      homeCourseList: [],
      authType: 0,
      modules: [Navigation, A11y, Autoplay]
    };
  },

  methods: {
    goDetail(item) {
      if (this.authType == 2 && !this.userInfo) {
        handleLogin();
      } else {
        window.open(item.course_url);
      }
    },

    async getHomeCourseList() {
      const homeCourse = await this.$http.getHomeSpoc({
        num: this.menu.num,
        menu_id: this.menu.menu_id
      });
      this.homeCourseList = homeCourse || [];
    },

    async getAuth() {
      const res2 = await this.$http.getConfigList();
      this.authType = res2.find(item => item.code == '10402') ? res2.find(item => item.code == '10402').auth_type : 0;
    },

    handleMore() {
      let navItemInfo = JSON.parse(sessionStorage.getItem('authInfo'));
      let nav = navItemInfo.find(item => item.function_id == '18300');

      if (nav) {
        window.location.href = `/teacherList.html?menuId=${nav.id}&name=${nav.nav_name}&tab=${this.menu.menu_id}`;
      }
    }

  }
};